import {
  COPY_ROUTE_FAILURE,
  DELETE_STEPS,
  DELETE_STEPS_FAILURE,
  DELETE_STEPS_SUCCESS,
  CLEAR_DELETED_ROUTE,
  FETCH_PROJECT_ROUTE_DATA,
  FETCH_PROJECT_ROUTE_DATA_FAIL,
  FETCH_PROJECT_ROUTE_DATA_SUCCESS,
  PROJECT_ROUTE_CONDITIONS_FETCH_STEP_DATA,
  PROJECT_ROUTE_CONDITIONS_SET_IS_SHOWN,
  PROJECT_ROUTE_CONDITIONS_SET_PLACEMENT,
  PROJECT_ROUTE_CONDITIONS_STEP_DATA_ERROR,
  PROJECT_ROUTE_CONDITIONS_STEP_DATA_SUCCESS,
  PROJECT_ROUTE_CONDITIONS_STEP_SELECTION_SAVED,
  PROJECT_ROUTE_EXAMPLES_STEP_DATA_SUCCESS,
  PROJECT_ROUTE_SET_ACTIVE_STEP,
  PROJECT_ROUTE_SET_IS_TRANSFER_FROM_REACTION,
} from './constants';

import { buildStepsData } from './utils/conditionsDataBuilder';

export const initialState = {
  // store last request params for caching
  requestParams: {
    projectId: null,
    routeId: null,
  },
  isTransferFromReaction: false,
  isLoading: false,
  response: null,
  error: null,
  activeStep: null,
  conditionsIsShown: undefined,
  conditionsPlacement: undefined,
  conditionsSteps: [], // [{ step: string, type: string, databaseId: string, reactionId: string,
  // examples: array, requested: boolean, isLoading: boolean, data: object }]
  deletedRoute: null,
  selectedExamplesCount: 0,
};

// eslint-disable-next-line default-param-last
export default function reducer(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case FETCH_PROJECT_ROUTE_DATA: {
      const requestParams = payload;
      return { ...state, isLoading: true, response: null, error: null, activeStep: null, conditionsSteps: [], requestParams };
    }
    case FETCH_PROJECT_ROUTE_DATA_SUCCESS: {
      // Check if we got response for the active request
      if (String(payload.id) !== String(state.requestParams.routeId)) {
        return state;
      }

      const conditionsSteps = buildStepsData(payload);
      // eslint-disable-next-line no-use-before-define
      const selectedExamplesCount = _countSelectedExamples(conditionsSteps);

      return {
        ...state,
        isLoading: false,
        response: payload,
        error: null,
        conditionsSteps,
        selectedExamplesCount,
      };
    }
    case FETCH_PROJECT_ROUTE_DATA_FAIL: {
      return { ...state, isLoading: false, response: null, error: payload, conditionsSteps: [] };
    }
    case PROJECT_ROUTE_SET_ACTIVE_STEP: {
      const { activeStep } = payload;
      return { ...state, activeStep };
    }
    case PROJECT_ROUTE_SET_IS_TRANSFER_FROM_REACTION: {
      const { isTransferFromReaction } = payload;
      return { ...state, isTransferFromReaction };
    }
    case PROJECT_ROUTE_CONDITIONS_FETCH_STEP_DATA: {
      const { conditionsSteps } = state;
      const { step } = payload;

      return {
        ...state,
        conditionsSteps: conditionsSteps.map((stepData) =>
          stepData.step === step ? { ...stepData, requested: true, isLoading: true, data: null } : stepData
        ),
      };
    }
    case PROJECT_ROUTE_EXAMPLES_STEP_DATA_SUCCESS: {
      const { conditionsSteps } = state;
      const { step, firstPriority, data } = payload;

      return {
        ...state,
        conditionsSteps: conditionsSteps.map((stepData) =>
          stepData.step === step
            ? {
                ...stepData,
                requested: true,
                isLoading: false,
                firstPriorityData: firstPriority ? data : stepData.firstPriorityData,
                lastPriorityData: firstPriority ? stepData.lastPriorityData : data,
              }
            : stepData
        ),
      };
    }
    case PROJECT_ROUTE_CONDITIONS_STEP_DATA_SUCCESS: {
      const { conditionsSteps } = state;
      const { step, data } = payload;

      return {
        ...state,
        conditionsSteps: conditionsSteps.map((stepData) =>
          stepData.step === step ? { ...stepData, requested: true, isLoading: false, data } : stepData
        ),
      };
    }
    case PROJECT_ROUTE_CONDITIONS_STEP_DATA_ERROR: {
      const { conditionsSteps } = state;
      const { step, error } = payload;

      Logger.error('RT Conditions error: ', error);

      return {
        ...state,
        conditionsSteps: conditionsSteps.map((stepData) =>
          stepData.step === step ? { ...stepData, requested: false, isLoading: false, data: null } : stepData
        ),
      };
    }
    case PROJECT_ROUTE_CONDITIONS_STEP_SELECTION_SAVED: {
      const { conditionsSteps } = state;
      const { stepId, selected, selectedIds } = payload;

      const updatedConditionsSteps = conditionsSteps.map((stepData) =>
        stepData.step === stepId
          ? {
              ...stepData,
              selected,
              examples: stepData.examples
                ? stepData.examples.map((e) => ({ ...e, selected: selectedIds ? selectedIds.includes(e.reactionId) : false }))
                : undefined,
              // eslint-disable-next-line no-use-before-define
              data: _getSyncedStepConditions(selectedIds, stepData.data),
            }
          : stepData
      );
      // eslint-disable-next-line no-use-before-define
      const selectedExamplesCount = _countSelectedExamples(updatedConditionsSteps);

      // sync selected examples/conditions in redux
      return {
        ...state,
        conditionsSteps: updatedConditionsSteps,
        selectedExamplesCount,
      };
    }
    case PROJECT_ROUTE_CONDITIONS_SET_PLACEMENT: {
      const { placement } = payload;
      return { ...state, conditionsPlacement: placement };
    }
    case PROJECT_ROUTE_CONDITIONS_SET_IS_SHOWN: {
      const { isShown } = payload;
      return { ...state, conditionsIsShown: isShown };
    }
    case COPY_ROUTE_FAILURE: {
      const { error } = payload;
      Logger.error('RT Copy Route error: ', error);
      return { ...state, error };
    }
    case DELETE_STEPS:
      return {
        ...state,
        isLoading: true,
        deletedRoute: null,
      };
    case DELETE_STEPS_SUCCESS:
      return {
        ...state,
        error: undefined,
        deletedRoute: action.payload,
      };
    case DELETE_STEPS_FAILURE:
      Logger.error('RT Edit Plan Delete Steps error: ', action.payload);
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case CLEAR_DELETED_ROUTE:
      return {
        ...state,
        deletedRoute: null,
      };
    default: {
      return state;
    }
  }
}

// update conditions selection state
const _getSyncedStepConditions = (selectedIds, data) => {
  if (!data || !data.conditions || !data.conditions.length) {
    return data;
  }
  const preparation = data.conditions[0];
  const details = {};

  Object.keys(preparation).forEach((key) => {
    if (key !== 'step') {
      details.conditions = preparation[key].map((c) => ({ ...c, selected: selectedIds ? selectedIds.includes(c.id.toString()) : false }));
      details.reactionId = key;
    }
  });

  return {
    conditions: [
      {
        ...preparation,
        [details.reactionId]: details.conditions,
      },
    ],
  };
};

const _countSelectedExamples = (conditionsSteps) => {
  let count = 0;
  conditionsSteps.forEach((stepData) => {
    if (stepData.examples && stepData.examples.length) {
      stepData.examples.forEach((e) => {
        if (e.selected) {
          count += 1;
        }
      });
    }
  });
  return count;
};
